exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list .list__item{display:flex;padding:.4rem;align-items:flex-start}", ""]);

// exports
